export default "__VITE_ASSET__CbH0pds___"